import { CardMedia, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import usePublic from '../../../utilities/usePublic';

const useStyles = makeStyles({
    media: {
        height: '13rem',
        backgroundSize: 'Contain',
        marginBottom: '1rem',
    },
});

const ResetPasswordHeader = () => {
    const styles = useStyles();
    const image = usePublic('assets/images/otpValidation.svg');

    return (
        <Grid xs={12} item>
            <CardMedia className={styles.media} image={image} />
        </Grid>
    );
};

export default ResetPasswordHeader;
